import { render, staticRenderFns } from "./clinicsCategoryGoodsItem.vue?vue&type=template&id=37c0905d&scoped=true"
import script from "./clinicsCategoryGoodsItem.vue?vue&type=script&lang=js"
export * from "./clinicsCategoryGoodsItem.vue?vue&type=script&lang=js"
import style0 from "./clinicsCategoryGoodsItem.vue?vue&type=style&index=0&id=37c0905d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c0905d",
  null
  
)

export default component.exports